import React, { useState } from 'react';
import cn from 'classnames';

import ActivationBox from '../ActivationBox';
import ActivationPaymentsModal from '../ActivationPaymentsList/ActivationPaymentsModal';
import PaymentItem from '../../../components/common/features/PaymentItem';
import Button from '../../../components/common/ui/Button';
import LeftIcon from '../../../assets/icons/common/LeftIcon';
import ErrorSmileIcon from '../../../assets/icons/activate/ErrorSmileIcon';
import fetchRequest from '../../../utils/fetchRequest';
import { useGetListPaymentsQuery } from '../../../redux/paymentsApi';

import styles from './styles.module.scss';

const ActivationFailedPayment = ({ paymentMethodId, backToActivation }) => {
  const { data: paymentsResp } = useGetListPaymentsQuery({
    include: 'addresses',
  });
  const paymentMethods = paymentsResp?.payment_methods || [];
  const paymentMethod = paymentMethods.find(
    (card) => card.id === paymentMethodId,
  );

  const [error, setError] = useState('');
  const [isOpenMopal, setIsOpenModal] = useState('');

  const closeModal = () => setIsOpenModal(false);

  const handleSendUpdateLink = async () => {
    setError('');
    try {
      await fetchRequest.post(
        `/payment-methods/${paymentMethod?.id}/send_update_email`,
        {
          shopify_gid: paymentMethod?.processor_payment_method_token,
        },
      );
      setIsOpenModal(true);
    } catch (e) {
      setError('Failed to send update link');
    }
  };

  return (
    <ActivationBox className={styles.wrapper}>
      <button className={styles.backButton} onClick={backToActivation}>
        <LeftIcon />
        <span className="text-xs">Back</span>
      </button>
      <div className={styles.content}>
        <div className={styles.paymentMethodWrapper}>
          {paymentMethod && (
            <PaymentItem
              className={styles.paymentItem}
              paymentDetails={paymentMethod}
              showUpdate={false}
            />
          )}
        </div>
        <div className={styles.errorWrapper}>
          <ErrorSmileIcon />
          <h3 className={cn('h3', styles.title)}>
            Oops, for some reason the payment failed.
          </h3>
          <p className={cn('text-s', styles.text)}>
            Check the availability of funds on your card or try updating your
            payment method.
          </p>
        </div>
      </div>
      {error && <p className={cn('text-error', styles.error)}>{error}</p>}
      <Button
        colorType="grey"
        className={styles.button}
        onClick={handleSendUpdateLink}
      >
        Update payment method
      </Button>
      <ActivationPaymentsModal isOpen={isOpenMopal} toggleModal={closeModal} />
    </ActivationBox>
  );
};

export default ActivationFailedPayment;
